var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.count > 0
    ? _c(
        "circle",
        _vm._g(
          {
            staticClass: "bubble-circle",
            attrs: {
              cx: _vm.cx,
              cy: _vm.cy,
              r: _vm.radius,
              fill: "rgba(204, 0, 0, 0.5)",
            },
          },
          _vm.$listeners
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }